import { createTheme } from '@mui/material/styles';

export const demoTheme = createTheme({
  colorSchemes: { light: true, dark: true },
  cssVariables: {
    colorSchemeSelector: 'class',
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 600,
      lg: 1200,
      xl: 1536,
    },
  },
  components: {
    MuiSvgIcon: {
      defaultProps: {
        fontSize: 'small', // small | medium | large | inherit
      },
    },
    // BUTTON
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 600,
          textTransform: 'none',
          padding: '8px 16px',
          fontSize: '0.875rem',
        },
        containedPrimary: {
          backgroundColor: '#1976d2',
          color: '#fff',
          '&:hover': {
            backgroundColor: '#1565c0',
          },
          '&:disabled': {
            backgroundColor: '#90caf9',
            color: '#fff',
          },
        },
        containedSecondary: {
          backgroundColor: '#f0f0f0',
          color: '#333',
          '&:hover': {
            backgroundColor: '#e0e0e0',
          },
          '&:disabled': {
            backgroundColor: '#fafafa',
            color: '#999',
          },
        },
      },
    },
    // SWITCH
    MuiSwitch: {
      styleOverrides: {
        root: {
          width: 36,
          height: 20,
          padding: 0,
        },
        switchBase: {
          padding: 2,
          '&.Mui-checked': {
            color: '#fff',
            transform: 'translateX(16px)',
            '& + .MuiSwitch-track': {
              backgroundColor: '#1976d2',
              opacity: 1,
            },
          },
          '&.Mui-disabled': {
            color: '#ccc',
            '& + .MuiSwitch-track': {
              backgroundColor: '#eee',
            },
          },
        },
        thumb: {
          width: 16,
          height: 16,
        },
        track: {
          borderRadius: 10,
          backgroundColor: '#ccc',
          opacity: 1,
        },
      },
    },
    // CHECKBOX
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#1976d2',
          '&.Mui-checked': {
            color: '#1976d2',
          },
          '&.Mui-disabled': {
            color: '#ccc',
          },
        },
      },
    },
  },
});
